import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Tables, Spinner } from "../../../../../../Components";
import { showError, showSuccess } from "../../../../../../Helper";
import { GetCommissionDetailsByIdAPI , DeleteCommissionDetailsAPI } from '../../../../../../Services' ; 
import { TableActions } from "../../../../../../Enums";
import { MessageConfirmDialog } from "../../../../../../SharedComponents";
 import { CommissionDetailsManagementDialog } from "./CommissionDetailsManagementDialog";

export const CommissionDetailsTable = ({
  translationPath,
  parentTranslationPath,
  data,
  filter,
  setFilter,
  reloadData,
  contactReletedWithDeveloperId , 
}) => {
  const { t } = useTranslation(parentTranslationPath, "Shared");
  const [isLoading, setIsLoading] = useState({ info: false });
  const [activeItem, setActiveItem] = useState(null);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);

  const GetCommissionDetailsById = useCallback(async () => {
    setIsLoading((item) => ({ ...item, info: true }));
    const res = await GetCommissionDetailsByIdAPI(
      activeItem && activeItem.commissionDetailId
    );
    if (res && res.ErrorId) {
      showError(t(`${translationPath}failed-to-get-commission-details`));
    } else if (!(res && res.status && res.status !== 200)) {
    }
    setIsLoading((item) => ({ ...item, info: false }));
  }, [activeItem]);

  const DeleteHandler = useCallback(async () => {
    if (activeItem && activeItem.commissionDetailId) {
      setIsLoading((item) => ({ ...item, delete: true }));

      const res = await DeleteCommissionDetailsAPI(
        activeItem && activeItem.commissionDetailId
      );
      if (res && res.ErrorId) {
        showError(t(`${translationPath}failed-to-delete-commission-details`));
      } else if (!(res && res.status && res.status !== 200)) {
        showSuccess(
          t(`${translationPath}delete-commission-details-successfully`)
        );
        setIsMissingInfoMSGOpen(false);
        setActiveItem(null);
        setFilter((item) => ({ ...item, pageIndex: 0 }));
      }
      setIsLoading((item) => ({ ...item, delete: false }));
    }
  }, [activeItem]);

  const tableActionClicked = useCallback(
    (actionEnum, item, focusedRow, event) => {
      event.stopPropagation();
      event.preventDefault();
      setActiveItem(item);

      if (actionEnum === TableActions.delete.key) {
        setIsMissingInfoMSGOpen(true);
      } else if (actionEnum === TableActions.editText.key) {
        setIsOpenEditDialog(true);
      }
    },
    []
  );

  const onPageIndexChanged = (pageIndex) => {
    setFilter((item) => ({ ...item, pageIndex }));
  };
  const onPageSizeChanged = (pageSize) => {
    setFilter((item) => ({ ...item, pageIndex: 0, pageSize }));
  };

  const getActionTableWithPermissions = () => {
    const list = [];
    list.push({
      enum: TableActions.editText.key,
      title: t(`${translationPath}Shared:edit`),
    });
    list.push({
      enum: TableActions.delete.key,
      title: t(`${translationPath}Shared:delete`),
    });
    return list;
  };

  const repeated = (list, filed) =>
    list &&
    list.map((item, index) => (
      <span key={index}>
        {" "}
        {item[filed]} {list.length - 1 != index && <span> , </span>}
      </span>
    ));


  useEffect(() => {
    if (activeItem) {
      GetCommissionDetailsById(activeItem.commissionDetailId);
    }
  }, [activeItem]);

  return (
    <div className="d-flex-column mt-2">
      <Spinner isActive={isLoading.info || isLoading.delete} isAbsolute />
      <Tables
        data={data?.result || []}
        headerData={[
          {
            id: 1,
            label: t(`${translationPath}commissionDetailId`),
            component: (item) => (
              <span>{t(`${translationPath}${item.commissionDetailId}`)}</span>
            ),
          },
          {
            id: 2,
            label: t(`${translationPath}commission-type`),
            component: (item) => (
              <span>{t(`${translationPath}${item.commissionType}`)}</span>
            ),
          },
          {
            id: 3,
            label: t(`${translationPath}value-from`),
            input: "valueFrom",
          },
          {
            id: 4,
            label: t(`${translationPath}value-to`),
            input: "valueTo",
          },
          {
            id: 5,
            label: t(`${translationPath}commission`),
            input: "commission",
          },
          {
            id: 6,
            label: t(`${translationPath}payment-terms`),
            input: "paymentTerms",
          },
          // {
          //   id: 7,
          //   label: t(`${translationPath}remarks`),
          //   input: "remarks",
          // },
          {
            id: 8,
            label: t(`${translationPath}commission-projects`),
            input: "commissionProjects",
            component: (item) =>
              repeated(item.commissionProjects, "propertyName"),
          },
          {
            id: 9,
            label: t(`${translationPath}createdBy`),
            input: "createdBy",
          },
          {
            id: 10,
            label: t(`${translationPath}createdOn`),
            input: "createdOn",
            isDate : true ,
          },
          
        ]}
        onPageIndexChanged={onPageIndexChanged}
        onPageSizeChanged={onPageSizeChanged}
        defaultActions={getActionTableWithPermissions()}
        actionsOptions={{
          onActionClicked: tableActionClicked,
        }}
        activePage={filter.pageIndex}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        itemsPerPage={filter.pageSize}
        totalItems={(data && data?.totalCount) || 0}
      />
      {isMissingInfoMSGOpen && activeItem && (
        <MessageConfirmDialog
          isDialogOpen={isMissingInfoMSGOpen}
          theme="warning"
          content={{
            heading: "delete-commission-details",
            body:
              t(
                `${translationPath}are-you-sure-to-delete-commission-details-id`
              ) +
              " " +
              ((activeItem && activeItem.commissionDetailId) || ""),
          }}
          confirmButton={{
            label: t(`${translationPath}confirm`),
            handler: () => DeleteHandler(),
          }}
          cancelButton={{
            label: t(`${translationPath}discard`),
            handler: () => {
              setIsMissingInfoMSGOpen(false);
            },
          }}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
        />
      )}
      {isOpenEditDialog && activeItem && (
        <CommissionDetailsManagementDialog
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          isOpen={isOpenEditDialog}
          onClose={() => {
            setIsOpenEditDialog(false);
            setActiveItem(null);
          }}
          onSave={(editItem) => {
            if (editItem) {
              setIsOpenEditDialog(false);
              setActiveItem(null);
              setFilter((item) => ({ ...item, pageIndex: 0 }));
            }
          }}
          commissionDetailsValues={activeItem}
          contactReletedWithDeveloperId={contactReletedWithDeveloperId}
        />
      )}
    </div>
  );
};
